import { render, staticRenderFns } from "./FormTemplateContainer.vue?vue&type=template&id=18e10032&"
import script from "./FormTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./FormTemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports